import React from 'react';

import './index.css';

export const Tabs = props => {
	const { tabs, tabNames, tabsDisabled, tab, setTab, icons, iconsPre, extras, children, style, buttons } = props;

	const innerContent = (t, i) => (
		<div className="flex flex-center">
			{icons && iconsPre && icons[i] && <i className={`mr10 fa ${icons[i]}`} />}
			{tabNames ? tabNames[t] : t}
			{icons && !iconsPre && icons[i] && <i className={`ml10 fa ${icons[i]}`} />}
			{extras && extras[i] && <span className="ml10">{extras[i]()}</span>}
		</div>
	);

	return (
		<div data-testid="tab-strip" className={`nav-tabs-${style || 'custom'}`}>
			<ul className="nav nav-tabs" role="tablist">
				{tabs.map((t, i) => {
					return (
						<li data-testid={`tab-${t}`} key={`tab-${i}`} className={tab === t ? 'active' : ''} role="none">
							{tabsDisabled && tabsDisabled[i] ? (
								<span className="tab-disabled">{innerContent(t, i)}</span>
							) : (
								<a
									role="tab"
									tabIndex={0}
									onClick={() => setTab && setTab(t)}
									onKeyUp={e => e.key === 'Enter' && setTab && setTab(t)}
									data-toggle="tab"
									aria-expanded="true"
								>
									{innerContent(t, i)}
								</a>
							)}
						</li>
					);
				})}
				{buttons && (
					<li key="tab-buttons" className="tab-buttons" role="none">
						{buttons}
					</li>
				)}
			</ul>
			{children && (
				<div className="tab-content">
					<div className="tab-pane active">{children}</div>
				</div>
			)}
		</div>
	);
};

export default Tabs;
